import CartItem from "../Components/CartItem";
import CartTotal from "../Components/CartTotal";
import { useSelector, useDispatch } from "react-redux";
import { increment, decrement } from "../Redux/Cart/action";

const Cart = () => {
	const dispatch = useDispatch();

	const cartProducts = useSelector((state) => {
		return state.filter((product) => product.cartQuantity > 0);
	});

	const totalPrice = cartProducts.reduce(
		(totalPrice, product) => totalPrice + product.price * product.cartQuantity,
		0
	);
	const totalItems = cartProducts.reduce(
		(totalItems, product) => totalItems + product.cartQuantity,
		0
	);

	const handleIncreaseCart = (id) => () => {
		dispatch(increment(id));
	};

	const handleDecreaseCart = (id) => () => {
		dispatch(decrement(id));
	};

	return (
		<div className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4">
			<div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
				{cartProducts.map((product) => (
					<CartItem
						key={product.id}
						title={product.title}
						onIncrease={handleIncreaseCart(product.id)}
						onDecrease={handleDecreaseCart(product.id)}
						quantity={product.cartQuantity}
					/>
				))}

				<div className="flex justify-center items-center text-center">
					<div className="text-xl font-semibold">
						<p>Total Item</p>
						<p className="text-5xl">{totalItems}</p>
					</div>
				</div>
			</div>

			<div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
				<CartTotal total={totalPrice} />
			</div>
		</div>
	);
};

export default Cart;
